import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'faceCertify',
  getInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/detail/${id}`)
  },
  getJuryPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/juryface/page`, queryParam)
  },
  commitPhoto (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/replacePhoto`, data)
  }
}
